<template>
    <div>
        <header-ton @boxLogin="IsUsersLogin" :actived="3"></header-ton>
        <login-box :showLogin="showLogin" @closeLogin="closeBox" ref="login"></login-box>
        <column-box @setSubject="setBoxSubject" :showColumn="showColumn" :classId="class_id" :columnId="column_id"
            :subjectId="subject_id" @closeColumn="closeBoxColumn" ref="column"></column-box>
        <div class="chapter">
            <div class="c_left">
                <div class="title">考试方向</div>
                <div class="meaus">
                    <div :class="class_id == item.id ? 'li active' : 'li'" @click="getColumn(item.id)"
                        v-for="(item, index) in classData" :key="index">
                        <img :src="item.thumb" width="24" height="24" />
                        {{ item.title }}
                    </div>
                </div>
            </div>
            <div class="c_right" v-loading="loading" element-loading-text="数据加载中">
                <header class="home_header">
                    <div class="context_box">
                        <b>{{ columnName }}</b> <span>{{ subjectName }}</span>
                        <div class="check_box" @click="changeColumn">
                            <div class="el-dropdown">
                                <p class=" el-dropdown-selfdefine  "><i>切换</i><span></span></p>
                            </div>
                        </div>
                    </div>
                    <div class="context_more" @click="reBack()">返回</div>
                </header>

                <div class="sq_conbox">

                    <!-- 章节练习 -->
                    <div class="tab-list">
                        <div class="tab_ul">
                            <div class="tab_top">
                                <div class="tab_top_header">
                                    <img :src="squareData.header" height="40" alt />
                                </div>
                                <div class="tab_top_namenick">
                                    <div class="tab_top_name">
                                        {{ squareData.nickname }}
                                    </div>
                                    <div class="tab_top_time">{{ squareData.created_at }}</div>
                                </div>
                            </div>
                            <div class="tab_center">
                                <span class="tags" v-if="squareData.status == 1">答疑中</span>
                                <span class="tag1" v-if="squareData.status == 2">已完成</span>
                                <span class="tag2" v-if="squareData.status == 0">待审核</span>
                                <span v-html="squareData.content"></span>
                            </div>
                            <div class="tab_footer">
                                <div class="tab_icon">
                                    <div class="tab_icon_from"><i class="el-icon-paperclip"></i>来源于：{{
            squareData.comefrom }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab_ul" v-for="(item, index) in  squareData.comm " :key="index">
                            <div class="tab_top">
                                <div class="tab_top_header">
                                    <img :src="item.teacher_thumb" height="40" alt />
                                </div>
                                <div class="tab_top_namenick">
                                    <div class="tab_top_name">
                                        {{ item.teacher_title }}
                                        <img src="https://ytk.jianjiangedu.cn/new_app/bg_22.png" />
                                    </div>
                                    <div class="tab_top_time">{{ item.created_at }}</div>
                                </div>
                            </div>
                            <div class="tab_center">
                                <span v-html="item.content"></span>
                            </div>
                        </div>

                        <div class="btns" v-if="squareData.status == 1">
                            <div class="btn_wait">追问</div>
                        </div>
                        <div class="btns grey" v-if="squareData.status == 2">
                            <div class="btn_wait">已完结</div>
                        </div>
                        <div class="btns grey" v-if="squareData.status == 0 ">
                            <div class="btn_wait">待老师回复</div>
                        </div>

                    </div>

                </div>

            </div>
        </div>
        <booter-ton></booter-ton>
    </div>
</template>


<script>
import HeaderTon from "@/components/HeaderTon";
import BooterTon from "@/components/BooterTon";
import LoginBox from "@/components/LoginBox";
import ColumnBox from "@/components/ColumnBox";

export default {
    components: {
        HeaderTon,
        BooterTon,
        LoginBox,
        ColumnBox,
    },
    data() {
        return {
            loading: true,
            subject_id: 0,
            selected: 0,
            class_id: 1,
            column_id: 0,
            columnName: '',
            subjectName: '',
            showLogin: false,
            showColumn: false,
            classData: [],
            columnData: [],
            subjectData: [],
            squareData: [],
            putData: [],
            teacherData: [],
            catData: [],
            id: 0,
        };
    },
    mounted() {
        var that = this;
        let class_id = sessionStorage.getItem("access-class_id");
        let column_id = sessionStorage.getItem("access-column_id");
        let subject_id = sessionStorage.getItem("access-subject_id");
        console.log(class_id);
        if (class_id == '' || class_id == null) {
            class_id = 1;
        }
        that.class_id = Number(class_id);
        if (column_id == '' || column_id == null) {
            column_id = 5;
        }
        if (subject_id == '' || subject_id == null) {
            subject_id = 8;
        }
        that.subject_id = Number(subject_id);
        that.column_id = Number(column_id);
        this.getSquareData();

        var query = that.$route.query;
        if (query.id) {
            that.id = query.id;
            that.getList();
        }
    },
    methods: {

        setBoxSubject(e) {
            console.log(e);
            this.page = 1;
            this.column_id = e.column_id;
            this.subject_id = e.subject_id;
            this.showColumn = false;
            this.getSquareData();
            this.getChapterList();
        },

        getColumn(e) {
            console.log(e);
            this.class_id = e;
            this.$refs.columnId = e;
            this.showColumn = true;
            sessionStorage.setItem("access-class_id", e);
        },

        reBack() {
            this.$router.push("/web/square");
        },

        //获取一级分类
        getList() {
            let that = this;
            let formData = {};
            formData.column_id = that.column_id;
            formData.limit = that.limit;
            that.axios.post("/getColumnCate", formData).then((res) => {
                if (res) {
                    that.classData = res.data;
                    that.getChapterList();
                }
            });
        },

        selectChange(e) {
            console.log(e);
            if (this.selected == e) {
                this.selected = 0;
            } else {
                this.selected = e;
            }
        },

        changeColumn() {
            this.showColumn = true;
            this.$refs.column.getColumnList();
        },

        //判断是否登录
        IsUsersLogin() {
            let token = sessionStorage.getItem("access-token");
            console.log(token);
            if (token) {
                return true;
            } else {
                this.showLogin = true;
                this.$refs.login.getMiQrCode();
                return false;
            }
        },

        closeBox(e) {
            this.showLogin = false;
        },

        closeBoxColumn(e) {
            console.log(e);
            this.showColumn = false;
        },

        //获取章节类别
        getChapterList() {
            let that = this;
            let formData = {};
            that.loading = true;
            formData.id = that.id;
            that.axios.post("/getSquareDetails", formData).then((res) => {
                if (res) {
                    that.squareData = res.data;
                    that.loading = false;
                }
            });
        },

        //加载更多
        getLoadingMore() {
            this.page = this.page + 1;
            this.getChapterList();
        },

        //获取章节类别
        getSquareData() {
            let that = this;
            let formData = {};
            that.loading = true;
            formData.column_id = that.column_id;
            formData.subject_id = that.subject_id;
            that.axios.post("/getSquareData", formData).then((res) => {
                if (res) {
                    console.log(res.data.cate);
                    that.columnName = res.data.column.title;
                    that.subjectName = res.data.subject.title;
                    that.teacherData = res.data.teacher;
                    that.catData = res.data.cate;
                    that.putData = res.data.puts;
                }
            });
        },

    },
};
</script>

<style scoped>
.chapter {
    width: 1200px;
    margin: 90px auto 20px auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.chapter .c_left {
    width: 21%;
    background: #fff;
    padding: 20px 0;
}

.chapter .c_left .title {
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
}

.chapter .meaus {
    display: flex;
    flex-direction: column;
}

.chapter .meaus .li {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: 60px;
    align-items: center;
    padding: 0 20px;
    cursor: pointer;
    border-left: 2px solid #ffffff;
}

.chapter .meaus .active {
    background: linear-gradient(90deg, #ffffff 0%, #f3f6ff 100%);
    color: #4171f9;
    border-left: 2px solid #4171f9;
}

.chapter .meaus .li:hover {
    background: linear-gradient(90deg, #ffffff 0%, #f3f6ff 100%);
    color: #4171f9;
    border-left: 2px solid #4171f9;
}

.chapter .meaus .li img {
    margin-right: 10px;
}

.chapter .c_right {
    width: 78%;
}

.sq_conbox {
    display: flow-root;
    min-height: 500px;
    margin-top: 10px;
}

.sq_conbox .tab_nav {
    background: #fff;
    margin: 10px 0;
    padding: 10px 20px;
    display: flex;
    flex-wrap: wrap;
}

.sq_conbox .tab_nav .li {
    width: 48%;
    height: 42px;
    line-height: 42px;
}

.sq_conbox .tab_nav .li span {
    width: 24px;
    background: #f6655b;
    color: #fff;
    padding: 2px 7px;
    border-radius: 5px;
    margin-right: 5px;
}

.sq_conbox .tab-list {
    display: flex;
    flex-direction: column;
}

.sq_conbox .tab-list .tab_ul {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 15px;
    display: flex;
    flex-direction: column;
}

.sq_conbox .tab-list .tab_top {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
}

.sq_conbox .tab-list .tab_top .tab_top_header {
    width: 40px;
    height: 40px;
    margin-right: 10px;
}

.sq_conbox .tab_more {
    height: 45px;
    line-height: 45px;
    background: #fff;
    text-align: center;
    font-size: 14px;
    color: #366dfa;
    cursor: pointer;
}

.tab_top_namenick {
    display: flex;
    flex-direction: column;
}

.tab_top_namenick .tab_top_name {
    font-size: 14px;
    line-height: 22px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.tab_top_namenick .tab_top_name img {
    width: 60px;
    height: 16px;
    margin-left: 5px;
}

.tab_top_namenick .tab_top_time {
    font-size: 12px;
    color: #999999;
}


.sq_conbox .tab-list .tab_top .tab_top_header img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.sq_conbox .tab-list .tab_center {
    position: relative;
    line-height: 26px;
    padding: 10px 0;
    text-indent: 10px;
    font-size: 15px;
}

.sq_conbox .tab-list .tab_detail {
    color: #4171f9;
    position: absolute;
    right: 0;
    bottom: 0;
    font-size: 14px;
}

.sq_conbox .tab-list .tab_footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: 30px 0 0 0;
}

.tab_icon {
    display: flex;
    flex-direction: row;
}

.tab_icon .tab_icon_view {
    width: 75px;
    text-align: center;
    font-size: 12px;
    line-height: 21px;
}

.tab_icon .tab_icon_from {
    font-size: 12px;
    line-height: 21px;
}

.tab_icon .tab_icon_view i,
.tab_icon .tab_icon_from i {
    margin-right: 3px;
}

.home_header {
    height: 70px;
    width: 100%;
    background: #fff;
    padding: 0 20px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.home_header .context_box {
    display: flex;
    align-items: center;
    justify-content: center;
}

.home_header .context_more {
    color: #fff;
    font-size: 14px;
    background: #4171f9;
    border-radius: 24px;
    line-height: 28px;
    display: flex;
    align-items: center;
    font-style: normal;
    cursor: pointer;
    padding: 0 26px;
}

.home_header .context_box>:not(span):not(p) {
    padding-right: 20px;
}

.home_header .context_box>b {
    font-size: 26px;
    line-height: 65px;
    height: 70px;
}

.home_header .context_box>span {
    font-size: 18px;
    line-height: 18px;
    color: #666;
    padding-right: 10px;
}

.home_header .context_box>.check_box {
    position: relative;
}

.home_header .context_box>:not(span):not(p) {
    padding-right: 20px;
}

.el-dropdown {
    display: inline-block;
    position: relative;
    color: #606266;
    font-size: 14px;
}

.home_header .context_box>.check_box p {
    color: #fff;
    font-size: 14px;
    background: #4171f9;
    border-radius: 24px;
    line-height: 36px;
    padding: 0 12px;
    line-height: 28px;
    display: flex;
    align-items: center;
    font-style: normal;
    cursor: pointer;
}

.home_header .context_box>.check_box p>i {
    font-style: normal;
    margin-right: 5px;
}

.home_header .context_box>.check_box p>span {
    display: inline-block;
    width: 15px;
    height: 12px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAyCAYAAABcfPsmAAADm0lEQVRIie1WXWgUVxT+Tu6d3czEpEqqYjChjS8aQYUI+iCJCCKoRQsVoQ8VfLA+lIIovgR9FFFB+yAooiK+iaKBIIWi+EMR0ZY2TbAvWxHxIUlht+zGnd3ZmSMn3llnk9nNbpPSFz843N255373/Hz3zmC+QcyMVCqFjo4OjIyMwLZtZLNZ9PT0TI0TExMoFov9ra2tjuM4jzo7OyfFj4imQmlqakImk4HjOOjt7UVTXICyiWVZUEotYOazjuM8yOfzdwuFwvV0Ot2pta6aV+yMUkoiW+F53nki2sbMw5ZljU9OTn6Zy+W6bdveT0S/ysbTERuhbdt9Y2NjQ9lsdpvWeoiIthPRF1rrS0qptZ7n3QWwI27tDMIgCGT3wWQyuZKIzgHYA+ANAFcpdUApNeB53lJmvs3M38cSSoGVUpL+GWa+XCqVFiYSiYNa60PM7IbOvu+jvb39RFdX117P83wAPwC4wMx2BWEul/sslUrdsSzrMICXAPqVUhdloyAIyiaEiUQCbW1tN3zf3wTgRRAE37a0tAwqpT4vEwZBcCufz+8wUhgE8EgKHkojUg64rgvP8+TvLwB+FD+t9VYAN8tdJqK/lFLitQFAUbRVKBRkqpWIFpUloTXS6XQ6k8lkk8mkPJpiZuanAF5HmyKFHwjLEInsJIBXUWPmk5L6tKYOGI4KHZY7HtHXKjM+NGM/M6/CTJTXVpf8e5TMuDncK/IsFrMRhvi0Tr8KwrBwblhDZg6j+TsadWTenbY2NsJuY+IUdvhGZF6erTDpd8dGaJowTkR5AHuZuc/MLzfjnsiajcz8wPxeBiDPzOMVhHKXEdFoqVT62nXdfUqpT0zxn8c0Qda0yOj7/vPm5uZrWuvRUBkUdwX9W0htY6+vKngM4BmAxbWcGiFsBrAewP2apJJynbaYmf/g9xiWK2v6uijhY24cfXGE9Z6UiqQi9ZyB/7XLdSEklKv/rUmnHvsHwLq4DULC7+TtOZ8RXjFjEcAuczHUMjmav8UyRtp+yginwMzrGtBnVdkcNRfBwbmkTMl7T+rxWwngJwBXARyPTrhbNn4ga0A2UrelAI4BOF3LsV7CFwC+Mu/hI0ZmVQklnYk6tCdfFJZZ981sETZy/tLmIykW0uU/ASxpgLAm/pOzLHZbPv8aOMtDtVJeA2D3fEY4DOB383/U1HO2s7yzFmEAYKshW23Sn1OEMDrcAuBnAJm5EH7ERzQKAO8Ae6gWTMg17TEAAAAASUVORK5CYII=) 0 -18px;
}

.sq_conbox .tab-list .tab_center span {
    font-size: 15px;
    padding: 2px 8px 2px 7px;
    line-height: 32px;
}

.sq_conbox .tab-list .tab_center .tags {
    background-color: #F87A12;
}

.sq_conbox .tab-list .tab_center .tag1 {
    background: url(https://ytk.jianjiangedu.cn/new_app/bg_19.png) 100% no-repeat;
    background-size: cover;
    color: #159A44 !important;
}

.sq_conbox .tab-list .tab_center .tag2 {
    background-color: #999999;
}


.grey {
    background: #cacaca !important;
    box-shadow: none !important;
}

.btns {
    width: 100%;
    height: 50px;
    background: linear-gradient(167deg, #5470FB, #758CFF);
    margin: 0 auto;
    text-align: center;
    color: #ffffff;
    box-shadow: 0px 0px 5px #2196F3;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
</style>